<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9541 5V15H5.9541V35H35.9541V15H30.9541V5H10.9541ZM25.9541 10H15.9541V15H25.9541V10ZM23.4541 22.5H18.4541L19.7041 26.25V30H22.2041V26.25L23.4541 22.5Z"
      class="fill-current"
    />
  </svg>
</template>
